module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.listCss
  }, [_c('user-survey-list', {
    attrs: {
      "title": _vm.title,
      "userId": _vm.userId,
      "selectedUserSurveyId": _vm.selectedUserSurveyId,
      "mode": _vm.mode
    },
    on: {
      "userSurveySelected": _vm.userSurveySelected,
      "addUserSurvey": _vm.addUserSurvey,
      "deleteUserSurvey": _vm.deleteUserSurvey
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.detailCss
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18832320","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/UserSurveys.vue
// module id = 1174
// module chunks = 1